import styled from "styled-components";

const AccountStyle = styled.div`
    .users-menu-filter-container{
        display: flex;
        justify-content: space-between;
    }
    .search-input-field{
        input{
            margin-bottom: 0px;
        }
    }

    .add-user-button{
        height: 2.5rem;
        min-width: 2.5rem;
        color: rgb(255, 255, 255);
        background-color: rgb(27, 104, 179);
        border: 1px solid rgb(27, 104, 179);

        &:hover{
            background-color: rgb(27, 104, 179) !important;
            border: 1px solid rgb(27, 104, 179) !important;
            color: rgb(255, 255, 255) !important;
        }
    }
    .hover_icons{
        display: flex;
        gap: 12px;
    }
    .delete_button{
        font-size: 0.889rem;
        height: 2.5rem;
        min-width: 2.5rem;
        color: rgb(255, 255, 255);
        background-color: rgb(209, 37, 37);
        border: 1px solid rgb(209, 37, 37);
        margin-right: 16px;
    }
    .cancel_button{
        font-size: 0.889rem;
        height: 2.5rem;
        min-width: 2.5rem;
        color: rgb(0, 0, 0);
        background-color: rgb(245, 245, 246);
        border: 1px solid rgb(245, 245, 246);
    }
    .conference_media_container{
        flex-flow: unset;
        flex-wrap: wrap;
        margin-top: 16px;
    }
    .conference_media_box{
        border-radius: 4px;
        cursor: pointer;
        background-color: rgb(255, 255, 255);
        box-shadow: rgb(193, 197, 200) 0px 0px 10px;
        padding: 12px;
    }
    .ant_divider_horizontal{
        margin: 10px 0px 16px 0px;
    }
    .strict-content{
        font-size: 0.889rem;
        font-weight: 400;
        color: rgb(158, 165, 169);
        
    }
    .conference_media_img{
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        .media_img_outer_box{
            display: flex;
            justify-content: center;
            align-items: center;
            max-height: 4.5rem;
            width: 4.5rem;
            background-color: rgb(245, 245, 246);
            border-radius: 0.3125rem;
            padding: 8px;
        }
        img{
            width: 54px;
        }
        .media_setting_icon{
            font-size: 22px;
        }
    }
    .media_title{
        margin-top: 18px;
        color: rgb(0, 0, 0);
        font-size: 0.889rem;
        font-weight: 700;
    }
    .media_content{
        color: rgb(158, 165, 169);
        font-size: 0.889rem;
        font-weight: 400;
    }
    .enable_switch_container{
        display: flex;
        align-items: baseline;
        gap: 10px;
        .enable_switch{
            width: 20%;
        }
    }

    .download_csv_con{
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 6px;
        font-size: 22px;
        width: 30px;
        height: 30px;
        background-color: rgb(245, 245, 246);
        cursor: pointer;
    }

    .yet-designed-pages{
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .yet-designed-pages-image{
        width: 40%;
    }
    .developement-content{
        font-size: 1.266rem;
        line-height: 1;
        color: rgb(0, 0, 0);
        margin-bottom: 1rem;
    }
    .developement-span-content{
        font-size: 1.125rem;
        font-weight: 400;
        color: rgb(158, 165, 169);
        margin-bottom: 1rem;
    }
    .developement-add-button{
        font-size: 0.889rem;
        height: 2.5rem;
        min-width: 2.5rem;
        color: rgb(255, 255, 255);
        background-color: rgb(27, 104, 179);
        border: 1px solid rgb(27, 104, 179)
    }
    .editIcon{
        font-size: 20px;
    }
    .deleteIcon{
        font-size: 20px;
    }
`;

export default AccountStyle;